import React from 'react';
import { Icon } from 'semantic-ui-react';
import TextField from 'components/ui/TextField';
import TextArea from 'components/forms/ui/TextArea';
import { useNJTaxSearch } from '../NJTaxSearchContext';
import { XIcon } from 'components/ui/icons';
import YearOrDate from './YearOrDate';

export const PilotCharges = () => {
  const {
    createPilotCharge,
    changePilotCharge,
    deletePilotCharge,
    pilotCharges,
    getYearOptions,
  } = useNJTaxSearch();
  return (
    <div style={{ paddingBottom: 32, marginTop: 32, borderBottom: '1px solid rgb(229, 229, 234)' }}>
      <div style={{ fontSize: 18, fontWeight: 900 }}>PILOT Charges</div>
      {pilotCharges.map((pc, index) => {
        console.log("pc:", pc);
        return (
          <div style={{ backgroundColor: '#f5f5f5', padding: 16, marginTop: 16, borderRadius: 4 }}>
            <div
              style={{
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'flex',
                justifyContent: 'flex-end',
                marginBottom: 8,
              }}
              onClick={() => deletePilotCharge(index)}
            >
              <XIcon />
            </div>
            <div style={{ display: 'flex', marginBottom: 24 }}>
              <YearOrDate
                options={getYearOptions()}
                customDate={pc.customDate}
                onChange={e => changePilotCharge('year', e, index)}
                yearValue={pc.year}
                onChangeCustomDate={e => {
                  changePilotCharge('customDate', e.target.value, index);
                }}
              />
              <TextField
                label="Quarter:"
                width="296px"
                value={pc.quarter || ''}
                onChange={e => changePilotCharge('quarter', e.target.value, index)}
                styles={{ marginLeft: 16 }}
              />
            </div>
            <TextArea
              value={pc.additionalInfo || ''}
              onChange={(e: any) => changePilotCharge('additionalInfo', e.target.value, index)}
              styles={{
                marginTop: 8,
                width: 296,
                height: 48,
                borderRadius: 5,
                resize: 'vertical',
                ':focus': {
                  outline: 'none',
                },
              }}
              label="Additional Information:"
              error={false}
              placeholder=""
              maxLength={52000}
            />
          </div>
        );
      })}
      <div style={{ cursor: 'pointer', display: 'flex', marginTop: 24 }} onClick={createPilotCharge}>
        <Icon name="plus" />
        <span style={{ fontWeight: 'bold', marginLeft: 4, fontSize: 16 }}>Add PILOT Charge</span>
      </div>
    </div>
  );
};
